
<template>
  <!--钥匙申请详情-->
  <div class="advanced-form">
    <a-form layout="vertical">
      <div class="card">
        <div class="card-head">
          <h3>基本信息</h3>
        </div>
        <div class="card-body">
          <a-row type="flex" justify="space-between">
            <a-col v-for="(item, index) of infoList" :key="index" v-bind="$store.state.advanced_colWidth">
              <a-form-item :label="item.label">
                <template v-if="Array.isArray(item.value)">
                  <p class="ant-form-text" v-for="(el, i) of item.value" :key="i">{{el}}</p>
                </template>
                <span class="ant-form-text" v-else>{{item.value}}</span>
              </a-form-item>
            </a-col>
          </a-row>
        </div>
      </div>
    </a-form>

    <div class="card">
      <div class="card-head">
        <h3>申请的钥匙列表</h3>
      </div>
      <div class="card-body">
        <x-tabula
          :searchList="[]"
          rowKey="item_id"
          :columns="columns"
          :listApi="listApi"
          :rowSelection="false"
        >
        </x-tabula>
      </div>
    </div>

    <template v-if="isAudit">
      <x-toolbar :toolBarList="toolBarList" :btnLoading="btnLoading"></x-toolbar>
    </template>

    <!--拒绝的弹窗-->
    <a-modal
      title="拒绝原因"
      :visible="visible"
      @ok="confirm"
      @cancel="visible=false"
      :confirmLoading="btnLoading.loading"
      okText="确认"
      cancelText="取消"
      destroyOnClose
      centered
      :maskClosable="false"
      :keyboard="false"
    >
      <a-form :form="form">
        <a-form-item v-bind="$store.state.modal_ItemLayout" label="拒绝原因">
          <a-textarea v-decorator="['check_remark', decoratorOptions.check_remark]" placeholder="请输入拒绝原因"></a-textarea>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'keyApplyDetail',
  data () {
    return {
      routeQuery: '',
      isAudit: false,
      visible: false,
      btnLoading: { loading: false },
      listApi: {
        url: ``,
        resHandle: this.listResHandle,
        searchHandle: ''
      },
      toolBarList: [
        {text: '通过', handle: (item) => this.passApply('1'), type: 'primary', loading: true, key: 'pass'},
        {text: '拒绝', handle: (item) => this.openModal(), type: 'danger', key: 'reject'}
      ],
      decoratorOptions: {
        check_remark: {
          rules: [
            { required: true, message: '请输入拒绝原因' },
            { min: 2, max: 20, message: '拒绝原因为2-20个字' }
          ]
        }
      },
      infoList: [
        {key: 'nick_name', label: '昵称', value: ''},
        {key: 'mobile', label: '手机号', value: ''},
        {key: 'room_list', label: '房间', value: []}
      ],
      columns: [
        { title: '位置', dataIndex: 'position_name', align: 'left', width: '' },
        { title: '设备名称', dataIndex: 'device_name', align: 'left', width: '' },
        { title: '设备编码', dataIndex: 'device_sncode', align: 'left', width: '' }
      ],
      tableData: []
    };
  },
  beforeCreate () {
    this.form = this.$form.createForm(this);
  },
  created () {
    this.$route.query.status === '0' ? this.isAudit = true : this.isAudit = false;
    if (this.$route.query.id) {
      this.routeQuery = this.$route.query.id;
      this.listApi.url = `/key_apply/${this.routeQuery}`;
    }
  },
  methods: {
    /* 打开弹窗 */
    openModal () {
      this.visible = true;
    },
    listResHandle (data) {
      for (let item in data) {
        this.infoList.forEach((el) => {
          if (el.key === item) {
            el.value = data[item];
          }
        });
      }
      return data.items;
    },
    /* 获取详情 */
    getDetail () {
      this.$get({
        url: `/key_apply/${this.routeQuery}`,
        params: {}
      }).then(({data}) => {
        for (let item in data) {
          this.infoList.forEach((el) => {
            if (el.key === item) {
              el.value = data[item];
            }
          });
        }
        this.tableData = data.items;
      });
    },
    /* 点击确定弹窗 */
    confirm () {
      this.form.validateFields((err, values) => {
        if (err) { return; }
        this.handleSubmit('2', values);
      });
    },
    /* 点击通过申请 */
    passApply (type) {
      this.$confirm({
        title: '确定通过申请？',
        centered: true,
        onOk: () => {
          this.handleSubmit(type);
        }
      });
    },
    /* 表单提交 */
    handleSubmit  (type, values) {
      this.$post({
        url: '/key_apply',
        params: {
          apply_id: this.routeQuery,
          ...values,
          status: type
        },
        btnLoading: this.btnLoading
      }).then((res) => {
        this.$store.commit('setOptData', true);
        this.visible = false;
        this.$message[type === '1' ? 'success' : 'error'](type === '1' ? '审核通过' : '审核已拒绝').then((res) => {
          this.$router.go(-1);
        });
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/device/keyApply/keyApplyDetail.vue